import priceFormatter from "@/utility/priceFormatter";
import Vue from "vue";
export default Vue.extend({
    props: {
        items: [],
    },
    data() {
        return {
            headers: [
                // {
                //   text: "Employee",
                //   value: "employeeName",
                //   align: "center",
                //   sortable: false,
                // },
                {
                    text: "Customer",
                    value: "customerName",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "Contact",
                    value: "customerContactPerson",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "Total Amount",
                    value: "totalAmount",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "Total Amount VAT",
                    value: "totalAmountInclVAT",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "Currency",
                    value: "currency",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "Invoice Date",
                    value: "invoiceDate",
                    align: "center",
                    sortable: false,
                },
                {
                    text: "Action",
                    value: "action",
                    align: "center",
                    sortable: false,
                },
            ],
            menu: {},
            date: {},
            activePicker: {},
        };
    },
    filters: {
        numberToSek(number) {
            return priceFormatter.fromNumber(number).toStringSEK();
        },
        toShortDate(date) {
            if (date) {
                return date.split("T")[0];
            }
        },
    },
    methods: {
        sumField(key, items) {
            // sum data in give key (property)
            return items.reduce((a, b) => a + (b[key] || 0), 0);
        },
        testing(foo, bar) {
            console.log(foo, bar);
        },
    },
    watch: {
        items(newValue) {
            console.log("====WATCH===");
            console.log(newValue);
            let dateValues = {};
            newValue.forEach((item) => {
                //@ts-ignore
                if (!this.date[item.id]) {
                    //@ts-ignore
                    dateValues[item.id] = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                        .toISOString()
                        .substr(0, 10);
                }
                else {
                    //@ts-ignore
                    dateValues[item.id] = this.date[item.id];
                }
            });
            this.date = dateValues;
        },
    },
});
